import meetingLocationTypes from 'constants/meeting-location-types';

export function determineLocationValueInputPlaceholder(type) {

  if (type === meetingLocationTypes.OTHER) {
    return 'Enter other location';
  }

  if (type === meetingLocationTypes.PHYSICAL) {
    return 'Enter physical location';
  }

  return 'Enter location';

}

export function determineLocationValueInputLabel(type) {

  if (type === meetingLocationTypes.OTHER) {
    return 'Other';
  }

  if (type === meetingLocationTypes.PHYSICAL) {
    return 'Physical';
  }

  return 'Location';

}